// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyByTOhxRvxt1EE6hszPd1IcZD-9qQ_31mk",
    authDomain: "pushnotificationdemo-de09d.firebaseapp.com",
    databaseURL: "https://pushnotificationdemo-de09d.firebaseio.com",
    projectId: "pushnotificationdemo-de09d",
    storageBucket: "pushnotificationdemo-de09d.appspot.com",
    messagingSenderId: "946780667548",
    appId: "1:946780667548:web:d63f40da4eebae8afa7759",
    measurementId: "G-HZJV9LY1E5"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
